import {UAParser} from 'ua-parser-js'

const parser = new UAParser(window.navigator.userAgent)

export const isDesktop = parser.getDevice().type === undefined
export const isTouchDevice = !isDesktop
